module.exports = __webpack_public_path__ + "images/mmm-04-desktop.png";